import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';

import { TellentSsoEffects } from './sso/tellent-sso-effects.service';
import { TellentSsoNamespace, TellentSsoReducer } from './sso/tellent-sso.store';

const provideTellentSsoState = provideState(TellentSsoNamespace, TellentSsoReducer);
const provideTellentSsoEffects = provideEffects(TellentSsoEffects);

export const tellentSsoData = [provideTellentSsoState, provideTellentSsoEffects];
